// extracted by mini-css-extract-plugin
module.exports = {"downloadButton":"DownloadButton_downloadButton__ph0-O","downloadIcon":"DownloadButton_downloadIcon__2MWP5"};